<template>
	<div class="text-center pt-5">
		<label class="radio-checkbox-label">
			<input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" :checked="! isCorporateCustomer" @click.stop="checkIfCorporateCostumer(false)">
			<span class="checkbox-custom" @click.stop="checkIfCorporateCostumer(false)" style="left: auto; top: auto;">
				<span v-if="! isCorporateCustomer" class="checkbox-dot" style="left: auto;"/>
			</span>
			<span style="margin-left: 25px; font-weight: bold;"> Privatperson</span>
		</label>
		<label class="radio-checkbox-label ml-5">
			<input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" :checked="isCorporateCustomer" @click.stop="checkIfCorporateCostumer(true)">
			<span class="checkbox-custom" @click.stop="checkIfCorporateCostumer(true)" style="left: auto; top: auto;">
				<span v-if="isCorporateCustomer" class="checkbox-dot" style="left: auto;"/>
			</span>
			<span style="margin-left: 25px; font-weight: bold;">Företagskund</span>
		</label>
	</div>
</template>

<script>
import bus from 'eventbus';

export default {
	data() {
		return {
			isCorporateCustomer: false,
		};
	},
	props: {
		value: {
			type: Boolean,
			required: true,
		},
		isLoggedIn: {
			type: Boolean,
		},
	},
	mounted() {
		this.isCorporateCustomer = this.value;
	},
	methods: {
		checkIfCorporateCostumer (is) {
			if (is != this.isCorporateCustomer) {
				this.isCorporateCustomer = is;
				bus.$emit('isCorporateCustomer', is);
			}
		},
	},
	watch: {
		value () {
			this.isCorporateCustomer = this.value;
		},
	},
};
</script>

